
import { computed, defineComponent, reactive } from 'vue';
import Icone from '../../components/Icone.vue';
import MeusAtalhos from './MeusAtalhos.vue';

export default defineComponent({
  name: 'MeusAtalhosMobile',
  components: {
    Icone,
    MeusAtalhos,
  },
  props: {
    visualizar: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:visualizar', 'abrirFavoritos'],
  setup(props, { emit }) {
    const state = reactive({
    });

    const computedVisualizar = computed({
      get: () => props.visualizar,
      set: (val: boolean) => {
        emit('update:visualizar', val);
      },
    });

    function abrirFavoritos() {
      computedVisualizar.value = true;
      emit('abrirFavoritos');
    }

    return {
      props,
      state,
      computedVisualizar,
      abrirFavoritos,
    };
  },
});
